import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class JobReviewChatMessage extends AbstractChatMessage {
  type = MessageTypes.JOB_REVIEW
  body: string = ''
  rates: Array<{
    category: number
    rate: number
  }>
  fromFreelancer: boolean

  constructor(data: LX.JobReviewChatMessage) {
    super(data)
    this.body = data.body.text
    this.fromFreelancer = data.body.type === 2
    this.rates = (data.body.relations?.Rate || []).map((rate) => ({ category: rate.category, rate: rate.rate }))
  }

  static fromServer(data: LX.JobReviewChatMessage) {
    return new JobReviewChatMessage(data)
  }

  getShortMessage() {
    return this.body || 'Review'
  }
}
